import { v4 } from 'uuid';

const createOptimisticPrivateTag = (name) => {
  const optimisticId = v4();
  return {
    isDraft: true,
    id: optimisticId,
    name
  };
};

export { createOptimisticPrivateTag };
//# sourceMappingURL=createOptimisticPrivateTag.js.map
